/**
 * Workspace seed data
 */

import { Workspace, User } from '@/types'

// Fixed workspace IDs for consistency
const WORKSPACE_IDS = {
  AXIOMA: 'axioma',
  CLARITY_OS: 'clarityos',
  ETHOS_AI: 'ethosai',
}

/**
 * Generate hard-coded workspaces with consistent data
 */
export function generateWorkspaces(users: User[]): Workspace[] {
  if (users.length < 3) {
    throw new Error('At least 3 users are required to seed workspaces')
  }

  const creator = users[0] // Use first user as creator for all workspaces

  // Distribute users across workspaces
  // Each workspace gets a subset of users
  const usersPerWorkspace = Math.ceil(users.length / 3)
  const axioma: Workspace = {
    id: WORKSPACE_IDS.AXIOMA,
    createdAt: new Date('2024-01-15T10:00:00Z'),
    updatedAt: new Date('2024-10-01T15:30:00Z'),
    creator,
    name: 'Axioma',
    email: 'team@axioma.io',
    logo: '',
    users: [creator, ...users.slice(1, usersPerWorkspace)],
    projects: [],
    tasks: [],
    messages: [],
    documents: [],
  }

  const clarityOS: Workspace = {
    id: WORKSPACE_IDS.CLARITY_OS,
    createdAt: new Date('2023-11-20T09:00:00Z'),
    updatedAt: new Date('2024-09-28T14:20:00Z'),
    creator,
    name: 'ClarityOS',
    email: 'contact@clarityos.com',
    logo: '',
    users: [creator, ...users.slice(usersPerWorkspace, usersPerWorkspace * 2)],
    projects: [],
    tasks: [],
    messages: [],
    documents: [],
  }

  const ethosAI: Workspace = {
    id: WORKSPACE_IDS.ETHOS_AI,
    createdAt: new Date('2024-03-10T11:00:00Z'),
    updatedAt: new Date('2024-10-02T16:45:00Z'),
    creator,
    name: 'EthosAI',
    email: 'hello@ethos-ai.com',
    logo: '',
    users: [creator, ...users.slice(usersPerWorkspace * 2)],
    projects: [],
    tasks: [],
    messages: [],
    documents: [],
  }

  return [axioma, clarityOS, ethosAI]
}
